import i18next from 'i18next';
import { I18nextProvider, initReactI18next } from 'react-i18next';
import resourcesToBackend from 'i18next-resources-to-backend';
import LanguageDetector from 'i18next-browser-languagedetector';
import React, { useEffect, useState } from 'react';
export const I18nProvider = ({ children }) => {
    const [loading, setLoading] = useState(true);
    useEffect(() => {
        i18next
            .use(initReactI18next)
            .use(resourcesToBackend((language, namespace) => {
            language = language.toLowerCase();
            namespace = namespace.toLowerCase();
            if (namespace === 'atomics')
                return import(`@testout/labsim-ui-atomics/dist/locales/${language}/labsim-ui-atomics.json`);
            return import(
            /* webpackChunkName: "i18n/[request]" */ `./locales/${language}/${namespace}.json`);
        }))
            .use(LanguageDetector)
            .init({
            debug: false,
            interpolation: { escapeValue: false },
            ns: ['common', 'atomics', 'labsimweb', 'questionviewers', 'viewerclient'],
            detection: { caches: [] },
            parseMissingKeyHandler: (key, defaultValue) => {
                return `###${key}###`;
            },
            fallbackLng: 'en',
        })
            .then(() => {
            setLoading(false);
        });
    }, []);
    if (loading)
        return null;
    return React.createElement(I18nextProvider, { i18n: i18next }, children);
};
//# sourceMappingURL=i18nProvider.js.map